import React, { useEffect, useState } from "react";
import { bulkuploading, bulkUploadFetch } from "./dispatch";
import { Card, Nav, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { sliderClasses } from "@mui/material";

function BulkFileUpload() {
  const [isDragging, setIsDragging] = useState(false);
  const [name, setName] = useState(null);
  const [file, setFile] = useState(null);
  const [selectedProcess, setSelectedProcess] = useState("");
  const [selectedId, setSelectedId] = useState("");

  const data = JSON.parse(localStorage.getItem("USER_DETAILS"));
  const dispatch = useDispatch();
  const { bulkDataUploadReducer } = useSelector((state) => state);
  const processDataArray = bulkDataUploadReducer?.processDate?.data?.pDATASET;
  console.log(processDataArray);

  useEffect(() => {
    dispatch(bulkUploadFetch(data));
  }, []);

  const isValidFileUploaded = (file) => {
    const validExtensions = ["xls", "xlsx", "xltm", "xlsb","csv"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    return validExtensions.includes(fileExtension);
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (isValidFileUploaded(selectedFile)) {
      setName(selectedFile.name);
      setFile(selectedFile);
    } else {
      alert("Kindly upload an Excel file only.");
      document.getElementById("file").value = "";
    }
  };

  const handleUpload = () => {
    if (!file) return alert("No file selected");
    if (!selectedProcess) return alert("Please select a process");

    const formData = new FormData();
    // formData.append("fileDetails", file);
    formData.append("file", file);
    formData.append("processName", selectedProcess); // Optional if backend needs itformData
    formData.append("processId", selectedId); // Optional if backend needs itformData
    formData.append("circleCode", data.pDATASET[0].CIRCLE_CODE);
    formData.append("circleId", data.pDATASET[0].CIRCLE_ID);
    formData.append("district", data.pDATASET[0].CIRCLE_NAME);

    formData.append("state", data.pDATASET[0].STATE_NAME);
    formData.append("userName", data.pDATASET[0].USERNAME);
    formData.append("sid", data);

    // Debug FormData entries
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": ", pair[1]);
    }

    dispatch(bulkuploading(formData,data)).then(() => {
      // Success callback
      setSelectedId("");
      setSelectedProcess('');
      setName("");
      setFile("");
      window.alert("file Upload successfully!");
    })
    .catch((error) => {
      // Handle error if needed
      console.error("An error occurred:", error);
    });
  };

  const handleProcess = (e) => {
    const id = e.target.value;
    setSelectedId(id);
  
    const selected = processDataArray.find(p => p.PROCESS_ID == id);
    setSelectedProcess(selected?.PROCESS_NAME || '');
  };
  
  
  
  return (
    <div className="bulkUpload">
      <Row className="mb-3">
        <Col sm={4}>
          <Form.Group>
            <Form.Label>
              <span className="req">*</span>Select upload process
            </Form.Label>
            <Form.Select
  name="Upload Process"
  aria-label="Select process"
  value={selectedId} // This must match the option value
  onChange={handleProcess}
>
  <option value="">Select upload process</option>
  {processDataArray?.map((service) => (
    <option key={service.PROCESS_ID} value={service.PROCESS_ID}>
      {service.PROCESS_NAME}
    </option>
  ))}
</Form.Select>


          </Form.Group>
        </Col>
      </Row>

      <div
        className={`file-drop-zone ${isDragging ? "dragging" : ""}`}
        onDragEnter={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragOver={(e) => e.preventDefault()}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          const droppedFile = e.dataTransfer.files[0];
          if (isValidFileUploaded(droppedFile)) {
            setName(droppedFile.name);
            setFile(droppedFile);
          } else {
            alert("Kindly upload an Excel file only.");
          }
        }}
        style={{
          height: "300px",
          alignContent: "center",
          backgroundColor: "#EEF9FF",
        }}
      >
        <label style={{ display: "inline-flex", cursor: "pointer" }}>
          <p>Drag and drop files here</p>
          <div
            style={{
              marginLeft: "10px",
              textDecorationLine: "underline",
              color: "blue",
            }}
          >
            Choose File
            <input
              type="file"
              name="file"
              style={{ display: "none" }}
              id="file"
              onChange={handleFileInputChange}
            />
          </div>
        </label>
      </div>

      <div
        style={{ display: "inline-flex", marginTop: 10, alignItems: "center" }}
      >
        <div style={{ marginRight: 10 }}>{name}</div>
        <Button variant="primary" onClick={handleUpload}>
          Upload
        </Button>
      </div>
    </div>
  );
}

export default BulkFileUpload;
